import MainTableApplication from '../../components/MainTableApplications/MainTableApplication'

const Applications = () => {

    return(
        <MainTableApplication type='clients' />
    )

}



export default Applications